import { render } from "./Privacy.vue?vue&type=template&id=f401aea4&scoped=true"
const script = {}

import "./Privacy.vue?vue&type=style&index=0&id=f401aea4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f401aea4"

export default script